import { useEffect, useRef } from 'react'

export default function useDidUpdate (callback, deps?: React.DependencyList) {
  const didMountRef = useRef<boolean>(false)

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true
    } else {
      callback()
    }
  }, deps)
}
